import { List } from 'immutable';
import FormattedHTMLMessage from 'I18n/components/FormattedHTMLMessage';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import FormattedPercentage from 'I18n/components/FormattedPercentage';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { NumberInput } from 'foundations-components/transitional/components/NumberInput';
import { Flex } from 'foundations-components/components/Flex';
import { View } from 'foundations-components/components/View';
import { Grid, GridItem } from 'foundations-components/transitional/components/Grid';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const getConversion = (goal, lastGoal) => {
  return !goal || !lastGoal ? null : goal / lastGoal;
};
const GoalEditor = ({
  goal,
  onChange
}) => {
  const property = /*#__PURE__*/_jsx("strong", {
    children: /*#__PURE__*/_jsx(FormattedHTMLMessage, {
      message: `reporting-data.properties.sessions.${goal.get('property')}`
    })
  });
  return /*#__PURE__*/_jsxs(Grid, {
    children: [/*#__PURE__*/_jsx(GridItem, {
      size: 3,
      children: /*#__PURE__*/_jsx(NumberInput, {
        textAlign: "right",
        value: goal.get('goal'),
        onChange: e => onChange(goal.set('goal', Number(e.target.value)))
      })
    }), /*#__PURE__*/_jsx(GridItem, {
      size: 9,
      padding: "0",
      children: /*#__PURE__*/_jsx(Flex, {
        alignItems: "center",
        blockSize: "100%",
        children: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "reporting-ui-components.customWidgets.editGoals.goals.monthlyGoal",
          options: {
            property
          }
        })
      })
    })]
  });
};
const getConversionRateText = conversionRate => {
  if (!conversionRate) {
    return null;
  }
  return /*#__PURE__*/_jsx(View, {
    marginInlineEnd: "200",
    as: "div",
    children: /*#__PURE__*/_jsx(FormattedReactMessage, {
      message: "reporting-ui-components.customWidgets.editGoals.goals.conversionRate",
      options: {
        conversionRate: /*#__PURE__*/_jsx(FormattedPercentage, {
          value: conversionRate * 100
        })
      }
    })
  });
};
const ConversionLine = ({
  conversionRate
}) => {
  return /*#__PURE__*/_jsxs(Flex, {
    flexGrow: "1",
    alignSelf: "center",
    paddingBlock: "800",
    children: [getConversionRateText(conversionRate), /*#__PURE__*/_jsx(View, {
      borderBlockStartWidth: "100",
      borderBlockStartStyle: "solid",
      borderBlockStartColor: "border-core-default",
      alignSelf: "center",
      flexGrow: "1",
      marginBlockStart: "100",
      marginBlockEnd: "0"
    })]
  });
};
const GoalsEditor = ({
  goals,
  onChange
}) => {
  const editBody = goals.reduce((body, goal, index) => {
    const goalEdit = /*#__PURE__*/_jsx(GoalEditor, {
      goal: goal,
      onChange: value => onChange(goals.set(index, value))
    }, goal.get('property'));
    if (index > 0) {
      const lastGoal = goals.get(index - 1);
      return body.push( /*#__PURE__*/_jsx(ConversionLine, {
        conversionRate: getConversion(goal.get('goal'), lastGoal.get('goal'))
      }, `conversion-${goal.get('property')}`), goalEdit);
    }
    return body.push(goalEdit);
  }, List());
  return /*#__PURE__*/_jsx(DialogBody, {
    children: editBody
  });
};
export default GoalsEditor;